"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fieldset = void 0;
var _react = _interopRequireDefault(require("react"));
require("./fieldset.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Fieldset = exports.Fieldset = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    className,
    legend,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("fieldset", {
    className: className,
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("legend", {
    className: "fs-h4 fw-500 mb-3"
  }, legend), children);
});